export default {"src":"/_next/static/media/AW-OurVision.5f77881d.svg","height":120,"width":200,"blurWidth":0,"blurHeight":0};